import React from "react";
import ReactDOM from "react-dom";
import { Amplify } from "aws-amplify";
import "aws-amplify/auth/enable-oauth-listener";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import config from "./config";
import "./index.css";

Amplify.configure({
  Auth: {
    // v6: move pool settings under Cognito + use userPoolClientId
    Cognito: {
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,  // ← was userPoolWebClientId
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      loginWith: {
        oauth: {
          domain: config.oauth.DOMAIN,
          scopes: ["openid"],
          redirectSignIn: [config.oauth.REDIRECT_SIGN_IN],
          redirectSignOut: [config.oauth.REDIRECT_SIGN_OUT],
          responseType: "code",
          providers: ["Google"]
        }
      },
      // optional: allow unauthenticated (replaces mandatorySignIn=false semantics)
      // allowGuestAccess: true
    }
  },
   API: {
    REST: {
      // 👇 This object key is the apiName you'll use in code
      notes: {
        endpoint: config.apiGateway.URL,   // e.g. "https://abc123.execute-api.us-east-1.amazonaws.com/prod"
        region:   config.apiGateway.REGION // e.g. "us-east-1"
        // optional: defaultAuthorizationMode: "iam" | "userPool" | "apiKey"
      }
    }
  }
});

ReactDOM.render(  
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);

registerServiceWorker();
